import $ from "./jquery"

// Use CJS entrypoints + call factories. The ESM (.mjs) path pulls nested
// datatables.net@3.x (from datatables.net-bs5) which breaks pageButton renderer.
import dataTablesFactory from "datatables.net/js/jquery.dataTables.js"
import bootstrap5Factory from "datatables.net-bs5/js/dataTables.bootstrap5.js"
import buttonsFactory from "datatables.net-buttons/js/dataTables.buttons.js"

const load = (mod) => {
  const factory = mod?.default ?? mod
  return typeof factory === "function" ? factory(window, $) : factory
}

if (!$.fn.dataTable) load(dataTablesFactory)
load(bootstrap5Factory)
load(buttonsFactory)

window.DataTable = $.fn.DataTable
window.dataTable = $.fn.dataTable

export default $.fn.DataTable
